import { Button } from 'components/UI/button/button.module';
import { BUTTON_SIZE, BUTTON_TYPE, MESSAGE_TEXT_INPUT_TYPE, MESSAGE_TYPE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import { addClass, readFromLs, setCustomTagHTML, updateLocalStorageMsgs, writeToLs } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

export const appendSkipButtonToRud = (chatData) => {
	const rudMessage = document.getElementById(`${readFromLs(LS().RUD_NODE)}`);
	if (rudMessage) {
		const { message } = chatData;
		const { options } = message?.data;
		const skipPostback = options[0];
		const skipElement = rudMessage.querySelector('skip-btn');
		if (skipElement) {
			const skip = new Button({
				type: BUTTON_TYPE.MINI,
				size: BUTTON_SIZE.SMALL,
				label: skipPostback.text || ENGT_CHAT.get('GENERIC_STRINGS')?.['SKIP'] || 'Skip',
				id: 'rud-skipBtn',
				style: 'margin-top: 12px;',
				applyOnHover: true,
				onClick() {
					if (skipPostback) {
						ENGT_CHAT.get('sendMessage')('skip', {
							message: {
								postback: skipPostback.payload,
								type: 'postback',
								text: 'Skip',
							},
							skipAppendToDom: true,
						});
					}
					const errInput = document.getElementById(`rud-input-${readFromLs(LS().RUD_NODE)}`);
					errInput?.remove();
					const errField = document.getElementById(`rud-error-${readFromLs(LS().RUD_NODE)}`);
					addClass(errField, 'engt-hidden');

					chatData.message = { ...message, text: 'Skipped', type: MESSAGE_TYPE.TEXT };
					onRudSuccess(chatData);
					clearRudInputArea();
				},
			}).render();
			setCustomTagHTML(skipElement, skip);
		}
	}
};

export const onRudSuccess = (chatData) => {
	const { message } = chatData;
	const id = chatData?.rud_message_id || readFromLs(LS().RUD_NODE);
	const rudMessage = document.getElementById(id);
	const input = document.getElementById(`rud-input-${id}`);
	const selectInput = document.getElementById(`form-select-box-rud-input-${id}`);
	const confirmBtn = document.getElementById(`confirmBtn-${id}`);
	const skipBtn = document.getElementById('rud-skipBtn');
	const usrPrompt = rudMessage?.querySelector('.engt-form-label');
	const datepicker = document.getElementById(`engtDatePicker-${id}`);
	const otpBtn = document.getElementById(`rud-otpBtn-${id}`);

	if (input) {
		if (input.type === 'password') {
			message.text = '*'.repeat(message.text.length);
		}
		input.remove();
	}
	if (selectInput) {
		if (selectInput.parentElement?.classList.contains('engt-input-with-select')) {
			selectInput.parentElement.remove();
		}
	}
	const node = rudMessage?.querySelector('.engt-rud-node');
	if (datepicker) {
		datepicker.remove();
		usrPrompt.classList.remove('engt-date-label');
		node?.insertBefore(usrPrompt, node.firstChild);
	}
	confirmBtn?.remove();
	skipBtn?.remove();
	otpBtn?.remove();

	if (rudMessage && !ENGT_CHAT.get('config.isRudUserMsgEnabled')) {
		const msg = document.createElement('strong');
		msg.style.width = '100%';
		msg.innerHTML = message.text;
		setCustomTagHTML(rudMessage.querySelector('validated-msg'), msg);
	}

	if (ENGT_CHAT.get('config.edit_user_input')) {
		const editBtn = node?.querySelector(`#${ENGT_CHAT.get('editFlowId')}`);
		if (editBtn) {
			editBtn.style.display = 'block';
		}
	}

	chatData.validated = message.text;
	chatData.message = { ...message, text: usrPrompt?.innerText };
	chatData.error = null;
	writeToLs(
		LS().TAB_MESSAGES,
		JSON.stringify({
			action: 'update_rud_msg',
			selectedValue: chatData.validated,
			rudId: id,
			tabId: ENGT_CHAT.get('socketId'),
		})
	);
	updateLocalStorageMsgs('message_id', id, chatData);
	localStorage.removeItem(LS().RUD_NODE);
};

export const onRudFailure = (message = {}, messageId) => {
	const id = messageId || readFromLs(LS().RUD_NODE);
	const rudMessage = document.getElementById(`${id}`);
	const confirmBtn = document.getElementById(`confirmBtn-${id}`);
	const errInput = document.getElementById(`rud-input-${id}`);
	const rudWrapper = document.querySelector('.rud-wrapper');
	const errorElement = document.getElementById(`rud-error-${id}`);
	if (errorElement) {
		errorElement.innerHTML = message.text;
		errorElement.classList.remove('engt-hidden');
	} else {
		const errorMsg = document.createElement('div');
		errorMsg.innerHTML = message.text;
		errorMsg.id = `rud-error-${id}`;
		errorMsg.classList.add('engt-error');
		const rudErrorArea = document.querySelector('rud-error-msg');
		if (rudErrorArea) {
			rudErrorArea.innerHTML = message.text;
			rudErrorArea.classList.add('engt-error');
		}
		setCustomTagHTML(rudMessage.querySelector('error-msg'), errorMsg);
	}
	if (confirmBtn) {
		confirmBtn.disabled = false;
		confirmBtn.classList.remove('engt-rud-disabled');
	}

	if (errInput) {
		errInput.disabled = false;
		if (rudWrapper) {
			rudWrapper.classList.add('engt-error-input');
		} else {
			errInput.classList.add('engt-error-input');
		}
		errInput.focus();
	}
};

export const clearRudInputArea = (isOldMessage = false) => {
	if (isOldMessage) return;
	const rudInputArea = document.querySelector('rud-input-area');
	if (rudInputArea) {
		while (rudInputArea.firstChild) {
			rudInputArea.removeChild(rudInputArea.firstChild);
		}
	}
};

export function rudonClick(id, message_id, input_type) {
	const textField = document.querySelector(`#rud-input-${id}`);
	const datepicker = document.querySelector(`#engtDatePicker-${id}`);
	let text = datepicker ? datepicker.getAttribute('data-selected-date') : textField?.value;
	const err = document.getElementById(`rud-error-${readFromLs(LS().RUD_NODE)}`);
	if (err) {
		addClass(err, 'engt-hidden');
	}
	if (this.data?.rud_display_settings) {
		const rudDisplaySettings = JSON.parse(this.data.rud_display_settings);
		if (rudDisplaySettings?.show_country_code && !ENGT_CHAT.get('config.isRudRespondBoxEnabled')) {
			const inputField = document.querySelector(`#rud-input-${id}.engt-form-input-text`);
			text = `${text}-${inputField?.value}`;
		}
	}
	if (text?.trim()) {
		ENGT_CHAT.get('sendMessage')(text.trim(), {
			skipAppendToDom: !(
				ENGT_CHAT.get('config.isRudUserMsgEnabled') && ENGT_CHAT.get('config.isRudRespondBoxEnabled')
			),
			message_id,
			isPassword: input_type === MESSAGE_TEXT_INPUT_TYPE.PASSWORD,
		});
		if (textField) {
			textField.disabled = true;
		}
		if (input_type === 'location') {
			clearRudInputArea();
			ENGT_CHAT.get('enableAllInput')();
		}
	}
}
